import { render, staticRenderFns } from "./RegionPanel.vue?vue&type=template&id=5125bb9d&"
import script from "./RegionPanel.vue?vue&type=script&lang=js&"
export * from "./RegionPanel.vue?vue&type=script&lang=js&"
import style0 from "./RegionPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports